import LoginStateService from '../Service/LoginStateService'
import { getElement, getElements } from '../Utility/Dom'

export const LOGIN_MODAL_OPENED_EVENT = 'login-modal:opened'

class LoginModal {
  private activeButton: HTMLElement | null = null
  private readonly closeButton: HTMLElement | null
  private readonly dialog: HTMLDialogElement | null
  private readonly openButtons: NodeListOf<HTMLElement>

  constructor() {
    this.closeButton = getElement('login-modal-close')
    this.dialog = getElement('login-modal') as HTMLDialogElement | null
    this.openButtons = getElements('login-button')
  }

  init(): void {
    if (this.dialog === null || this.openButtons.length === 0) return
    this.addEvents()
  }

  private addEvents(): void {
    this.openButtons.forEach((button: HTMLElement): void => {
      button.addEventListener('click', (): void => this.open(button))
    })

    this.closeButton?.addEventListener('click', (): void => this.dialog?.close())

    this.dialog?.addEventListener('click', (event: MouseEvent): void => {
      if (event.target === this.dialog) this.dialog.close()
    })

    this.dialog?.addEventListener('close', (): void => this.onClose())
  }

  private onClose(): void {
    this.activeButton?.setAttribute('aria-expanded', 'false')
    this.activeButton?.focus()
    this.activeButton = null
  }

  private open(button: HTMLElement): void {
    if (this.dialog === null) return
    this.activeButton = button
    button.setAttribute('aria-expanded', 'true')
    this.dialog.showModal()

    const startView = LoginStateService.isLoggedIn() ? 'profile' : 'email'
    this.dialog.dispatchEvent(new CustomEvent(LOGIN_MODAL_OPENED_EVENT, {
      bubbles: true,
      detail: { startView }
    }))
  }
}

const loginModal = new LoginModal()
loginModal.init()
